function Footer() {
  return (
    <footer style={{ background: "#222", color: "white", padding: "1rem", textAlign: "center" }}>
      <p>© {new Date().getFullYear()} SICOR Ventas y servicios de Coahuila. Todos los derechos reservados.</p>
    </footer>
  );
}

export default Footer;
